import gql from "graphql-tag";

export const GET_BULKUPLOAD_HISTORY = gql`
    query BulkUploadsHistoryQuery(
        $authorName: String
        $errorsCount: Int
        $status: String
        $filename: String
        $uploadType: String
        $before: String
        $after: String
        $first: Int
        $last: Int
    ) {
        bulkUploadsHistory(
            authorName: $authorName
            errorsCount: $errorsCount
            status: $status
            filename: $filename
            uploadType: $uploadType
            before: $before
            after: $after
            first: $first
            last: $last
        ) @connection(key: "bulkLobTerminations_terminations") {
            pageInfo {
                totalCount
                endCursor
                hasNextPage
            }
            edges {
                node {
                    errorsCount
                    filename
                    status
                    createdDate
                    errorFileId
                    authorName
                    uploadType
                }
                cursor
            }
        }
    }
`;
